import React, { createContext, useContext, useState, useEffect } from "react";

const HospitalContext = createContext(null);

export const HospitalProvider = ({ children }) => {
  const [hospitalId, setHospitalId] = useState(null);

  useEffect(() => {
    const hospitalRaw = localStorage.getItem("Hospital");
    const hospitalData = hospitalRaw ? JSON.parse(hospitalRaw) : null;

    if (hospitalData?._id) {
      setHospitalId(hospitalData._id);
    } else {
      // Fallback: Try to get hospitalId from User
      const userRaw = localStorage.getItem("User");
      const userData = userRaw ? JSON.parse(userRaw) : null;
      // console.log('userData', userData?.hospitalId?._id);
      setHospitalId(
        (typeof userData?.hospitalId === 'object' && userData.hospitalId !== null)
          ? userData.hospitalId._id
          : userData?.hospitalId || null
      );
    }
  }, []);

  return (
    <HospitalContext.Provider value={{ hospitalId }}>
      {children}
    </HospitalContext.Provider>
  );
};

export const useHospital = () => useContext(HospitalContext);
